import { render, staticRenderFns } from "./saas-nsr-footer.vue?vue&type=template&id=32506a7e&scoped=true"
import script from "./saas-nsr-footer.vue?vue&type=script&lang=js"
export * from "./saas-nsr-footer.vue?vue&type=script&lang=js"
import style0 from "./saas-nsr-footer.vue?vue&type=style&index=0&id=32506a7e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32506a7e",
  null
  
)

export default component.exports